<motn-drawer-gap-from-top
  [addToTopGap]="60"
  (clickedOutside$)="cancel()"
>
  <h3>
    {{schedule.UUID ? 'Edit' : 'Create'}} Schedule

    <div
      class="toggle-container"
    >
      {{selectedEnabled ? '' : 'Disabled'}}

      <label
        class="toggle red-green"
      >
        <input
          [(ngModel)]="selectedEnabled"
          type="checkbox"
        >
        <span class="slider"></span>
      </label>
    </div>
  </h3>

  <div class="outer-content">
    <div
      class="inner-flex-container"
    >
      <div
        class="inner-content"
        [class.disabled]="!selectedEnabled"
      >
        <h2>
          Days of the Week
        </h2>

        <div class="days-table">
          <div class="days-row">
            @for (day of daysOfWeek; track $index) {
              <div class="day">
                <div>
                  {{day}}
                </div>

                <label
                  class="toggle small"
                >
                  <input
                    [(ngModel)]="selectedDaysOfWeek[$index]"
                    type="checkbox"
                  >
                  <span class="slider"></span>
                </label>
              </div>
            }
          </div>
        </div>
      </div>

      <div
        class="inner-content"
        [class.disabled]="!selectedEnabled"
      >
        <h2>
          Time of Day
          <button
            class="small white indigo"
            (click)="infoDialog(INFO_TIME_ZONE)"
          >
            Time Zone Info
          </button>
        </h2>

        <motn-time-picker
          [hour]="selectedHour"
          [minute]="selectedMinute"
          [period]="selectedPeriod"
          [minuteStep]="5"
          (hourChange)="selectedHour = $event"
          (minuteChange)="selectedMinute = $event"
          (periodChange)="selectedPeriod = $event"
        ></motn-time-picker>
      </div>

      <div
        class="inner-content"
        [class.disabled]="!selectedEnabled"
      >
        <h2>
          Value
        </h2>

        @if (tile.Type === SIMPLE_ANALOG) {
          <div>
            <div
              class="analog-input"
            >
              <input
                type="number"
                [(ngModel)]=selectedValue
              >
              <label>
                {{getAnalogStructure().DisplayRawUnits}}
              </label>
            </div>
          </div>
        }

        @if (tile.Type === SIMPLE_BOOL || tile.Type === SIMPLE_MULTISTATE) {
          <div>
            <div
              class="fake-select"
              [innerHTML]="getValueOptionText(''+(+selectedValue))"
              (click)="valueOptionsShown = true"
            ></div>

            @if (valueOptionsShown) {
              @if (tile.Type === SIMPLE_BOOL) {
                <motn-popover-menu
                  [optionGroup]="valueOptions"
                  [overlayPositions]="overlayPositions"
                  (clickedOption$)="selectedValue = !!(+$event.id)"
                  (clickedAnywhere$)="valueOptionsShown = false"
                ></motn-popover-menu>
              }

              @if (tile.Type === SIMPLE_MULTISTATE) {
                <motn-popover-menu
                  [optionGroup]="valueOptions"
                  [overlayPositions]="overlayPositions"
                  (clickedOption$)="selectedValue = +$event.id"
                  (clickedAnywhere$)="valueOptionsShown = false"
                ></motn-popover-menu>
              }
            }
          </div>
        }
      </div>

      @if (false) {
        <div
          class="inner-content"
          [class.disabled]="!selectedEnabled"
        >
          <h2>
            <div>
              Expire After

              <div class="optional">Optional</div>
            </div>
            <button
              class="small white indigo"
              (click)="infoDialog(INFO_EXPIRATION)"
            >
              What Is This?
            </button>
          </h2>

          <div
            class="clearable-input"
          >
            <input
              type="datetime-local"
              [(ngModel)]="expiration"
              (ngModelChange)="onChangeExpiration()"
            >
            @if (expiration) {
              <button
                class="small yellow"
                (click)="expiration = ''"
              >
                Clear
              </button>
            }
          </div>
        </div>
      }
    </div>

    <button
      [class.loading]="saving"
      (click)="save()"
    >
      <span [innerText]="'Save'"></span>
      <motn-spinner></motn-spinner>
    </button>

    <button
      class="alt"
      (click)="cancel()"
    >
      Cancel
    </button>

    @if (schedule.UUID) {
      <button
        class="red"
        [class.loading]="deleting"
        (click)="delete()"
      >
        <span [innerText]="'Delete'"></span>
        <motn-spinner></motn-spinner>
      </button>
    }
  </div>
</motn-drawer-gap-from-top>
